import React from "react";
import { FaExclamationTriangle, FaCheck } from "react-icons/fa";
import {useState, useEffect} from "react";
require("../../assets/stylesheets/Utils/DoneMessage.css");

export default function DoneMessages({ text, code, visibility}) {
  const [messageVisibility, setMessageVisibility] = useState({visibility});
  const closeMessage = () => {
    setMessageVisibility(false);
  };

  useEffect(() => {}, [messageVisibility]);
  return (
    <div
      className={`doneMessage ${
        messageVisibility
          ? code == 200
            ? "successMessage"
            : "errorMessage"
          : "hideMessage"
      }`}
      onClick={closeMessage}
    >
      {/* <img src={require('../../assets/images/alert-decoration.png')} alt="" /> */}
      <div className="alertIcon">
        {code == 200 ? <FaCheck /> : <FaExclamationTriangle />}
      </div>
      <div className="alertText">{text}</div>
    </div>
  );
}
